module.exports = __webpack_public_path__ + "frontend/images/green/carousel/static/mobile/0.png?16eafd72b42608e389232563d841412c";